import { apiUrl } from '.';
import { authService } from './';

const search = async (data) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/users/search?name=' + data.name, requestOptions);
    return res;
}

const globalSearch = async (value) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/users/global-search?value=' + value, requestOptions);
    return res;
}

const getDOSemails = async (value) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/users/dso-emails?value=' + value, requestOptions);
    return res;
}

const bulkRegistration = async (data) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/users/bulk-registration', requestOptions);
    return res;
}

export const userService = {
    search,
    globalSearch,
    bulkRegistration,
    getDOSemails
};